
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SkillSuggestionResponse,
  ValidationError,
} from '../models';
import {
    SkillSuggestionResponseFromJSON,
    SkillSuggestionResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AutocompleteSkillRequest {
    q: string;
}

/**
 * 
 */
export class AutocompleteSkillApi extends runtime.BaseAPI {

    /**
     * Suggest skills
          */
    async autocompleteSkillRaw(requestParameters: AutocompleteSkillRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<SkillSuggestionResponse>>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling autocompleteSkill().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<SkillSuggestionResponse>>({
            path: `/search/api/autocomplete/skill`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(SkillSuggestionResponseFromJSON);
        return response;
    }

    /**
     * Suggest skills
          */
    async autocompleteSkill(requestParameters: AutocompleteSkillRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<SkillSuggestionResponse>> {
        const response = await this.autocompleteSkillRaw(requestParameters, initOverrides);
        return response._data;
    }

}
